import {
  property,
  subclass,
} from "@arcgis/core/core/accessorSupport/decorators";
import { messageBundle, tsx } from "@arcgis/core/widgets/support/widget";
import Widget from "@arcgis/core/widgets/Widget";
import "./PopoverManager.scss";

import AppT9N from "../../../t9n/App/App.json";
import PopoverManagerViewModel from "./PopoverViewModel";
import { whenOnce } from "@arcgis/core/core/reactiveUtils";
import NavBarViewModel from "src/app/ui/NavBar/NavBarViewModel";
import { isEnterprise } from "../../../app/utils/appUtils";

export enum PopoverIds {
  popover1 = "popover1",
  popover2 = "popover2",
  popover3 = "popover3",
  popover4 = "popover4",
  popover5 = "popover5",
  popover6 = "popover6",
  popover7 = "popover7",
  popover8 = "popover8",
  popover9 = "popover9",
  popover10 = "popover10",
}

export const ReleaseTag = "R2.2024_Opened";

@subclass("Landing.widgets.PopoverOnboarding.Popover")
export default class PopoverManager extends Widget {
  //--------------------------------------------------------------------------
  //
  //  Properties
  //
  //--------------------------------------------------------------------------

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof AppT9N;

  @property()
  viewModel: PopoverManagerViewModel = new PopoverManagerViewModel({});

  @property()
  currentPopoverIndex: number = 0;

  @property()
  isClosed: boolean = localStorage.getItem(ReleaseTag) === "true";

  @property()
  learnMoreSignalFromManager: boolean;

  @property()
  navbarVM: NavBarViewModel;
  //--------------------------------------------------------------------------
  //
  //  Lifecycle Methods
  //
  //--------------------------------------------------------------------------
  constructor(props?: any) {
    super(props);
  }

  postInitialize() {
    localStorage.setItem(ReleaseTag, "true");
    whenOnce(() => this.appMessages).then(() => {
      this.viewModel.appMessages = this.appMessages;
      this.viewModel.createPopovers();
    });

    this.watch("currentPopoverIndex", () => {
      switch (this.currentPopoverIndex) {
        case 0:
          this.navbarVM.setNavbarRoute("browseAll");
          break;
        case 1:
          this.navbarVM.setNavbarRoute("browseAll");
          break;
        case 2:
          this.navbarVM.setNavbarRoute("browseAll");
          break;
        case 3:
          this.navbarVM.setNavbarRoute("browseAll");
          break;
        case 4:
          this.navbarVM.setNavbarRoute("myApps");
          this.navbarVM.suggestionsButtonSignal = true;
          break;
        case 5:
          this.navbarVM.setNavbarRoute("myApps");
          break;
        case 6:
          this.navbarVM.setNavbarRoute("myApps");
          break;
        case 7:
          this.navbarVM.setNavbarRoute("featured");
          this.navbarVM.suggestionsButtonSignal = true;
          break;
        case 8:
          this.navbarVM.setNavbarRoute("featured");
          this.navbarVM.rightSidebarSignal = true;
          break;
        case 9:
          this.navbarVM.setNavbarRoute("featured");
          break;
        default:
          break;
      }
    });
  }

  render() {
    const { refElementId, title, content, icon } =
      this.viewModel.popovers[this.currentPopoverIndex] || {};
    const { next, learnMore, finish } = this.appMessages.popoverOnboardingExtra;
    return !isEnterprise(this.navbarVM.portal) && !this.isClosed ? (
      <calcite-popover
        key={"popover-manager" + this.currentPopoverIndex}
        class="onboarding-popover"
        label={title}
        reference-element={refElementId}
        closable
        open
        afterCreate={(el) => {
          this.listenForClose(el);
        }}
      >
        <div class="onboarding-popover-root">
          <div class="onboarding-header">
            <calcite-icon icon={icon}></calcite-icon> <h3>{title}</h3>
          </div>
          <p>{content}</p>
          <div class="footer">
            <span>
              {this.currentPopoverIndex + 1} of {this.viewModel.popovers.length}
            </span>
            <div>
              <calcite-button
                key="learnMore"
                class="learn-more-button"
                appearance="transparent"
                onclick={this.openLearnMore.bind(this)}
              >
                {learnMore}
              </calcite-button>
              {this.currentPopoverIndex ===
              this.viewModel.popovers.length - 1 ? null : (
                <calcite-button
                  key="nextPopover"
                  id="nextPopoverBtn"
                  appearance="outline"
                  onclick={this.nextPopover.bind(this)}
                >
                  {next}
                </calcite-button>
              )}
            </div>
          </div>
        </div>
      </calcite-popover>
    ) : (
      <div></div>
    );
  }

  private listenForClose(el: HTMLCalcitePopoverElement) {
    el.addEventListener("calcitePopoverClose", () => {
      this.isClosed = true;
    });
  }

  private openLearnMore() {
    this.learnMoreSignalFromManager = true;
  }

  private nextPopover() {
    if (this.currentPopoverIndex < this.viewModel.popovers.length - 1) {
      this.currentPopoverIndex++;
    }

    setTimeout(() => {
      const nextPopoverBtn: HTMLCalciteButtonElement = document.getElementById(
        "nextPopoverBtn"
      ) as any;
      nextPopoverBtn?.focus();
      nextPopoverBtn?.setFocus();
    }, 100);
  }
}
